var ENUMS = {
    FILE_SIZE_LIMIT: 2
}

module.exports = ENUMS
